import styled from 'styled-components';

export const DotsText = styled.span`
  font-weight: bold;
  font-size: 18px;
  background-image: radial-gradient(circle at center, red 20%, transparent 20%);
  background-position: top right;
  background-repeat: repeat-x;
  background-size: 1em 0.3em;
  padding-top: 0.4em;
`;
export const SpeechBubble = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 15px;
  padding: 9px 10px 5px;
  border: 1px solid #d02525;
  background-color: #ffffff;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #000000;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    border-style: solid;
    border-width: 15px 7.5px 0 7.5px;
    border-color: #d02525 transparent transparent;
    translate: -50% 100%;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    border-style: solid;
    border-width: 12.8px 6.4px 0 6.4px;
    border-color: #ffffff transparent transparent;
    translate: -50% 100%;
  }
`;
export const SpeechDiagonal = styled.p`
  align-items: center;
  display: flex;
  justify-content: center;
  &::before,
  &::after {
    background-color: #444444;
    border-radius: 5px;
    content: '';
    height: 1px;
    width: 16px;
  }
  &::before {
    margin-right: 10px;
    transform: rotate(60deg);
  }
  &::after {
    margin-left: 10px;
    transform: rotate(-60deg);
  }
`;

export const Maru = styled.div`
  height: 45px;
  width: 45px;
  border-radius: 50%;
  line-height: 50px;
  text-align: center;
  font-weight: 700;
  color: #ffffff;
  background-color: #d02525;
  position: absolute;
  top: -15px;
  left: 0;
  right: 0;
  margin: 0 auto;
`;
export const SlickPrev = styled.div`
  &::before {
    content: none;
    display: none;
  }
`;
export const SlickNext = styled.div`
  &::before {
    content: none;
    display: none;
  }
`;
